/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inventory_Quick_Navigation_DescriptionInputs */

const en_inventory_quick_navigation_description = /** @type {(inputs: Inventory_Quick_Navigation_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Access different inventory management sections`)
};

const es_inventory_quick_navigation_description = /** @type {(inputs: Inventory_Quick_Navigation_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accede a diferentes secciones de inventario`)
};

/**
* | output |
* | --- |
* | "Access different inventory management sections" |
*
* @param {Inventory_Quick_Navigation_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const inventory_quick_navigation_description = /** @type {((inputs?: Inventory_Quick_Navigation_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inventory_Quick_Navigation_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_inventory_quick_navigation_description(inputs)
	return es_inventory_quick_navigation_description(inputs)
});